import { GetterTree } from 'vuex';
import { IDevicesState } from '../types';
import { RootState } from '../types';
import { DeviceInfo } from '@/common/apis/DeviceApi';

export const getters: GetterTree<IDevicesState, RootState> = {
    sorted: (state) => {
        const result: DeviceInfo[] = [];
        if (!state || !state.devices) {
            return result;
        }
        for (const n of Object.keys(state.devices)) {
            const device = state.devices[n];
            if (state.devices[n].owner && device.connections && device.connections.filter((s) => s.online || false).length > 0
                && (!state.resettedDevice || state.resettedDevice !== device.number)) {
                result.push(state.devices[n]);
            }
        }
        const getPoints = (device: DeviceInfo): number => {
            let points = 0;
            if (!device.connections) {
                return points;
            }
            for (const conn of device.connections) {
                if (conn.online) {
                    switch (conn.connectionType || '') {
                        case 'local':
                            points += 4;
                            break;
                        case 'ble':
                            points += 2;
                            break;
                        default:
                            points += 1;
                            break;
                    }
                }
            }
            return points;
        };
        result.sort((a, b) => {
            const ap = getPoints(a);
            const bp = getPoints(b);

            const nameA = (a.number || '').toUpperCase();
            const nameB = (b.number || '').toUpperCase();

            if (ap !== bp) {
                return bp < ap ? -1 : 1;
            } else {
                return nameA === nameB ? 0 : (nameA < nameB ? -1 : 1);
            }
        });

        return result;
    },
    devices: (state) => state.devices,
    newDevices: (state) => {
        const result: DeviceInfo[] = [];
        if (!state || !state.devices) {
            return result;
        }
        for (const n of Object.keys(state.devices)) {
            const device = state.devices[n];
            if (device && !device.owner && device.connections
                && device.connections.filter((s) => s.online || false).length > 0) {
                result.push(device);
            }
        }
        return result;
    },
    deviceInfo(state): (deviceNumber: string) => DeviceInfo | null {
        return (deviceNumber: string): DeviceInfo | null => {
            if (!state.devices) {
                return null;
            }
            return state.devices[deviceNumber];
        };
    },
    getDeviceProgress(state): (deviceNumber: string) => number {
        return (deviceNumber: string) => {
            const progress = state.progress[deviceNumber];
            if (!progress || !progress.bytesTotal || !progress.bytesTransferred) {
                return 0;
            }
            return progress.bytesTransferred / progress.bytesTotal * 100;
        };
    },
};
